import React from 'react';
import { Link } from "react-router-dom";

import ListButton from './listButton.js'
import Pagination from './pagination.js'
import SectionHeader from './sectionHeader.js'
import TechnologyIconAndName from './technologyIconAndName.js'
import TechnologyVersionWithScore from './technologyVersionWithScore.js'
import VersionRef from './versionRef.js'

import { _printDate, _printShortFullDate } from '../helpers/helpers.js'

import {RtHeader, RtPage, RtButton, RtSection, RtDomainTechnology, RtCategorizedTechnology} from '../../../server/routes/route-types.js'
import {TechnologySection} from '../../../server/routes/website.js'

export interface CategoryData {
     CategoryTechnologyCount?: number;
     Technology: RtDomainTechnology;
}

interface DomainTechnologyProps {
    cat: CategoryData;
    dayFormat?: boolean;
    tooltip?: string;
    merge?: boolean;
}


type TechnologiesData = {
    Technologies: RtDomainTechnology[];
    NewTechnologies?: RtCategorizedTechnology[];

    Header?: RtHeader,
    Pages?: RtPage[];
    Button?: RtButton;

};

interface DomainTechnologiesProps {
    technologies: TechnologiesData;
    link?: string;
    anchor?: string;
//    merge?: boolean;
}

export function DomainTechnology({ cat, dayFormat, tooltip, merge }: DomainTechnologyProps) {

    let technology: RtDomainTechnology = cat.Technology;
    let andMore: string | null = null;
    if (merge) {
        if (cat.CategoryTechnologyCount === 2)
            andMore = `, and 1 more technology`;
        else if (cat.CategoryTechnologyCount! > 2)
            andMore = `, and ${cat.CategoryTechnologyCount! - 1} more technologies`;
    }
    return (
        <tr>
            <td>
                <Link
                    to={`/technology-type/${technology.CategoryURL}`}
                    className="link-hover"
                    title={`${technology.Category} category market share and usage statistic`}
                >
                    {technology.Category}
                </Link>
            </td>
            <td>
                {' '}
                <TechnologyIconAndName
                    technology={technology.Technology}
                    technologyURL={technology.TechnologyURL}
                    technologyIcon={technology.TechnologyIcon}
                    title={`${technology.Technology} customers list, historic trends, and recent website additions`}
                />
                {' '}
                {
                    technology.Version &&
                    <>
                    <VersionRef technology={technology}/>
                    {' '}
                    <TechnologyVersionWithScore
                            technology={{
                                TechnologyURL: technology.TechnologyURL,
                                Version: technology.Version,
                                Bucket: technology.Bucket!,
                                PercentNewerVersion: technology.PercentNewerVersion!
                            }}
                            tooltip ={tooltip}
                        />
                    </>
                }
                {
                    andMore &&
                    <>
                    {andMore}
                    </>
                }
            </td>
            <td>
                { dayFormat ? _printShortFullDate(technology.UsedSince) : _printDate(technology.UsedSince)}
            </td>

            <td>
                { dayFormat ? _printShortFullDate(technology.UsedSince) : _printDate(technology.LastSeen)}
            </td>
        </tr>
    )
}

function compareTechByCategory(a: CategoryData, b: CategoryData): number {
	// workaround null element
    if (a === null || b === null)
        return (a || '') < (b || '') ? -1 : 1;

    if (a.Technology.Category < b.Technology.Category)
        return -1;
    if (a.Technology.Category > b.Technology.Category)
        return 1;
    return 0;
}

function mergeByCategory(arr: RtCategorizedTechnology[]): CategoryData[] {

    const outCategoryData: CategoryData[] = 
        arr.map(obj => {
            const outCategory: CategoryData = {
                Technology: obj,
                CategoryTechnologyCount: obj.CategoryTechnologyCount
            } 
            return outCategory;
        })
    return outCategoryData;

    // return arr.reduce((acc: CategoryData[], obj: RtCategorizedTechnology) => {
    //   // Check if the category already exists in the accumulator
    //   let category: CategoryData | undefined = acc.find(item => item.Category === obj.Category);

    //   if (category) {
    //     // If category exists, push the technology to the list of technologies
    //     category.Technology.push(obj);
    //   } else {
    //     // If category does not exist, create a new entry
    //     acc.push({
    //       Category: obj.Category,
    //       CategoryTechnologyCount: obj.CategoryTechnologyCount!,
    //       Technology: [obj]
    //     });
    //   }

    //   return acc;
    // }, []);
}

function returnUnmerged(arr: RtDomainTechnology[]): CategoryData[] {
    return arr.map((obj) => ({
        Technology: obj
    }));
}

export default function DomainTechnologies({ technologies, link, anchor /*, merge*/ }: DomainTechnologiesProps) {

    if (!technologies) return null;

    let catList: CategoryData[] | null = null;

    // if (merge) {
        if (technologies.NewTechnologies) {
            catList = mergeByCategory(technologies.NewTechnologies);
        }
    //     } else {
    //         if (technologies.Technologies) {
    //             catList = mergeByCategory(technologies.Technologies);
    //         }
    //     }
    // }
    // else {
    //     if (technologies.NewTechnologies) {
    //         catList = returnUnmerged(technologies.NewTechnologies);
    //     } else {
        else if (technologies.Technologies) {
                catList = returnUnmerged(technologies.Technologies);
            }
    catList = catList!.sort((a, b) => compareTechByCategory(a, b));


    return (
        <div className="row row-50">
            <div className="col-12">
                <SectionHeader header={technologies.Header} link={link} anchor={anchor}/>
                <div className="table-outer table-rounded table-responsive-lg">
                    <table className="table-custom table-custom-striped table-custom-primary  ">
                        <thead>
                            <tr>
                                <th style={{ width: '25%' }}>Technology Type</th>
                                <th style={{ width: '50%' }}>Technology</th>
                                <th style={{ width: '12%' }}>First detected</th>
                                <th style={{ width: '13%' }}>Last detected</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                catList.map((cat: CategoryData, indexKey: number) =>
                                    <DomainTechnology cat={cat} tooltip='1' /*merge={merge}*/ key={indexKey}/>
                                )
                            }
                        </tbody>
                    </table>
                    <Pagination pages={technologies.Pages} />
                    <ListButton button={technologies.Button} />
                </div>
            </div>
        </div>
    )
}